const expenseTypes = {
  GET_EXPENSES: "GET EXPENSES",
  UPDATE_A_EXPENSES: "UPDATE A EXPENSE",
  CREATE_OR_UPDATE_EXPENSES: "CREATE OR UPDATE EXPENSES",
  DELETE_EXPENSE: "DELETE EXPENSE",
  ADD_EXPENSE: "ADD EXPENSE",
};

export default expenseTypes;
